import { Map } from 'immutable';
import { getTheme, setTheme as setThemeApp } from '@app/Theme';

//Action Types
export const Types = {
  SET_THEME: 'APP/SET_THEME',
};

//Action Creators
export const setTheme = (theme) => ({ type: Types.SET_THEME, theme });

// Reducer
const initialState = Map({
  theme: getTheme(),
});

const handleSetTheme = (state, action) => {
  const { theme } = action;

  setThemeApp(theme);

  return state
    .set('theme', (theme) ? theme : getTheme());
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.SET_THEME: return handleSetTheme(state, action);

    default: return state;
  }
}
